import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const InsuranceDisclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Insurance Disclaimer - Wisdom Consultancy</title>
      </Helmet>

      <section className="bg-gray-50 py-20 min-h-screen">
        <div className="container-custom max-w-4xl bg-white rounded-3xl shadow-xl p-8 md:p-14 border border-gray-100">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0b1c39] mb-8 border-b pb-6">
            Insurance Disclaimer
          </h1>

          <div className="prose prose-lg text-gray-600 max-w-none space-y-6">
            <p>
              By accessing and using this website, you acknowledge that you have read, understood, and agreed to the terms of this disclaimer.
            </p>
            <p>
              Wisdom Consultancy provides insurance-related information and assistance for various insurance products including Life Insurance, Health Insurance, Motor Insurance, and General Insurance products offered by insurance companies.
            </p>
            <p>
              Insurance products and services displayed on this website are subject to the terms, conditions, exclusions, limitations, underwriting process, and guidelines of the respective insurance companies.
            </p>
            <p>
              The information available on this website is provided solely for general informational and educational purposes and should not be construed as insurance advice, legal advice, financial guarantee, claim assurance, or policy commitment.
            </p>
            <p>
              Policy issuance and claim settlement are at the sole discretion of the respective insurance company and are governed by the applicable policy terms and underwriting guidelines.
            </p>
            <p>
              Wisdom Consultancy and its representatives do not guarantee:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Policy approval</li>
              <li>Claim settlement</li>
              <li>Specific returns or bonuses</li>
              <li>Premium rates</li>
              <li>Tax benefits</li>
              <li>Continuity of benefits</li>
              <li>Accuracy of insurer illustrations</li>
            </ul>
            <p>
              Insurance premiums, benefits, riders, bonuses, and coverage are subject to change by the respective insurance companies without prior notice.
            </p>
            <p>
              Users are advised to carefully read:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Policy brochure</li>
              <li>Benefit illustration</li>
              <li>Prospectus</li>
              <li>Policy wording</li>
              <li>Exclusion clauses</li>
              <li>Terms and conditions</li>
            </ul>
            <p>
              before purchasing any insurance policy.
            </p>
            <p>
              The website may contain links to third-party websites including insurance company websites for user convenience. Wisdom Consultancy shall not be responsible for the content, accuracy, or availability of such external websites.
            </p>
            <p>
              All logos, trademarks, insurer names, and product names belong to their respective owners and are used strictly for identification and informational purposes only.
            </p>
            <p>
              Wisdom Consultancy reserves the right to modify, update, or remove any content on this website without prior notice.
            </p>
            <p className="font-bold">
              Insurance is the subject matter of solicitation.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default InsuranceDisclaimer;
